// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titleContainer_Qoof3{
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.title_IYDMQ {
    color: var(--_10a37f-background);
  }`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewAgentComponent/Ttitle/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;AACA;IACI,gCAAgC;EAClC","sourcesContent":[".titleContainer{\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n.title {\n    color: var(--_10a37f-background);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleContainer": `titleContainer_Qoof3`,
	"title": `title_IYDMQ`
};
export default ___CSS_LOADER_EXPORT___;
